import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: "root"
  })

  export class DownloadsService {


    constructor(private http: HttpClient) {}

    //Downloads

    public downloadPoliticaInvest(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Downloads/PoliticaInvestimentos`, {responseType: "blob"});
    }

    public downLoadTermoAbrapp(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Downloads/DownLoadTermoAbrapp`, {responseType: "blob"});
    }

  }
